export enum MapZonesType {
  PreferredArea = "Courier's preferred area",
  Partition = 'Partitioning',
}
